module.exports = __webpack_public_path__ + "img/鲁健.16e5d02f.jpg";